import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import QueryChat from "./QueryChat";
import getParamsFromString from "../../../Utils/getParamsFromString";
import JsonScreenHoc from "../../../../../HocHelpers/JsonScreenHoc";

const Chat = (props) => {
    const {properties: {sourceId, isChatBot, readOnly, ourUser}, styles, globalValues, screenName} = props;
    const [source, setSource] = useState("");
    useEffect(() => {
        setSourceProps();
    }, [globalValues]);

    const setSourceProps = () => {
        if (sourceId) {
            let params = getParamsFromString(sourceId || '', globalValues, screenName);
            if (params.length === 0) {
                setSource(sourceId)
            } else {
                setSource(params)
            }
        }
    };
    return (
        <QueryChat
            sourceId={source}
            styles={styles[0]}
            readOnly={readOnly}
            isChatBot={isChatBot}
            ourUser={ourUser}
        />
    )
};

Chat.propTypes = {
    properties: PropTypes.shape({
        sourceId: PropTypes.string,
        type: PropTypes.oneOf(['live', 'query'])
    }),
    styles: PropTypes.array
};
Chat.defaultProps = {
    properties: {
        type: 'query'
    },
    styles: [{}]
};

export default JsonScreenHoc(Chat)